export const downloadFile = (fileName = '', blob: Blob) => {
  const url = window.URL.createObjectURL(blob);

  // Create a link to trigger the download
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName; // Specify the filename
  a.click();

  // Clean up the URL object
  window.URL.revokeObjectURL(url);
};

export const generateUUID = () => {
  return crypto.randomUUID();
};

export const downloadPDFFile = (fileName: string, content: string) => {
  const blob = new Blob([content], { type: 'application/pdf' });
  downloadFile(fileName, blob);
};

export const downloadExcelFile = (
  fileName: string,
  content: BlobPart
) => {
  const blob = new Blob([content], {
    type:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  downloadFile(fileName, blob);
};
